/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	SVGIcon
} from '@ba/ba-ui-carbon-toolkit';
import StringResources from './../nls/StringResources';
import classnames from 'classnames';
import changeVisualizationIcon from '@ba/ba-graphics/dist/icons-js/chart--multitype_32';

import './visPreview.scss';

const CLASS_NAME = 'vis-recommender__preview';

class VisualizationAutoMode extends Component {

	render() {

		const {
			isHorizontal,
			isSelected,
			size
		} = this.props;

		const wrapperClassNames = classnames({
			[`${CLASS_NAME}--wrapper__horizontal`]: isHorizontal,
			[`${CLASS_NAME}--wrapper`]: !isHorizontal
		});

		const classNames = classnames(
			CLASS_NAME,
			[`${CLASS_NAME}__size-${size}`],
			{
				[`${CLASS_NAME}--horizontal`]: isHorizontal,
				[`${CLASS_NAME}--vertical`]: !isHorizontal,
				[`${CLASS_NAME}--selected`]: isSelected
			}
		);

		const visBoxClassNames = classnames(
			`${CLASS_NAME}__preview-box`,
			`${CLASS_NAME}__autoIcon`,
			{
				[`${CLASS_NAME}--horizontal__preview-box`]: isHorizontal,
				[`${CLASS_NAME}--vertical__preview-box`]: !isHorizontal
			}
		);

		const label = StringResources.get('autoVis');

		return (
			<div className={wrapperClassNames}>
				<div className={classNames}
					onClick={this._onSelect}
					onKeyDown={this._onKeyDown}
					tabIndex={0}
				>
					<div className={visBoxClassNames}>
						<div className={`${CLASS_NAME}__autoIcon`}>
							<SVGIcon iconId={changeVisualizationIcon.id} size="large" />
						</div>
						<div className="ba-common-truncatedText__text" aria-label={label}>
							{label}
						</div>
					</div>
				</div>
			</div>
		);
	}

	_onSelect = (e) => {
		// TODO: do we need this?
		if (!e.isDefaultPrevented()) {
			e.preventDefault();
			this.props.onSelect();
		}
	}

	_onKeyDown = (e) => {
		if (e.keyCode === 13 || e.keyCode === 32) {
			this._onSelect(e);
		}
	}
}

VisualizationAutoMode.propTypes = {
	isHorizontal: PropTypes.bool,
	isSelected: PropTypes.bool,
	onSelect: PropTypes.func,
	size: PropTypes.oneOf(['small', 'medium'])
};

VisualizationAutoMode.defaultProps = {
	isHorizontal: true,
	isSelected: false,
	onSelect: () => {},
	size: 'small'
};

export default VisualizationAutoMode;


// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/preview/VisualizationAutoMode.js